import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';

const LazyRoute = ({ children }) => {
  return (
    <Suspense
      fallback={
        <div className="d-flex justify-content-center py-6">
          <Spinner animation="border" />
        </div>
      }
    >
      {children}
    </Suspense>
  );
};

LazyRoute.propTypes = {
  children: PropTypes.node
};

export default LazyRoute;
